import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { GermanInsuranceTypes } from '../../../../db/enums/misc-enums.js';
import { HealthInsurance } from '../../../../healthinsurance/entities/HealthInsurance.js';

@Entity()
export class ANSozialVersicherung extends AdornisEntity {
  static override _class = 'ANSozialVersicherung';

  @Field(() => String)
  versicherungsStatus: Maybe<GermanInsuranceTypes>;

  @Field(() => String)
  rentenVersicherungsNr: Maybe<string>;

  @Field(() => String)
  krankenkassenID: Maybe<string>;

  @DataLoadedField(() => HealthInsurance, ({ krankenkassenID }) => krankenkassenID)
  krankenkassen: Maybe<HealthInsurance>;
}
